"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./collectionCredentialsBlock.scss");
const CollectionSingleCredential_1 = __importDefault(require("../CollectionSingleCredential/CollectionSingleCredential"));
const CollectionCredentialsBlockLoader_1 = __importDefault(require("./collectionCredentialsBlockLoaders/CollectionCredentialsBlockLoader"));
function CollectionCredentialsBlock(props) {
    return props.loading ? (react_1.default.createElement(CollectionCredentialsBlockLoader_1.default, Object.assign({}, props))) : (react_1.default.createElement("div", { id: "collection-credentials-block" },
        react_1.default.createElement("span", { className: "credentials-title" }, props.translate("credentials").toString()),
        react_1.default.createElement("div", { className: "credentials-grid" }, props.deliveries.map((e, i) => (react_1.default.createElement(CollectionSingleCredential_1.default, { key: i, isMobile: props.isMobile, credential: e }))))));
}
exports.default = CollectionCredentialsBlock;
